export const NPVR_FETCH_EVENT_LIST_INIT = 'NPVR_FETCH_EVENT_LIST_INIT';
export const NPVR_FETCH_EVENT_LIST_SUCCESS = 'NPVR_FETCH_EVENT_LIST_SUCCESS';
export const NPVR_FETCH_EVENT_LIST_ERROR = 'NPVR_FETCH_EVENT_LIST_ERROR';

export const NPVR_FETCH_SERIES_LIST_INIT = 'NPVR_FETCH_SERIES_LIST_INIT';
export const NPVR_FETCH_SERIES_LIST_SUCCESS = 'NPVR_FETCH_SERIES_LIST_SUCCESS';
export const NPVR_FETCH_SERIES_LIST_ERROR = 'NPVR_FETCH_SERIES_LIST_ERROR';
export const NPVR_FETCH_SERIES_LIST_CLEAR = 'NPVR_FETCH_SERIES_LIST_CLEAR';

export const NPVR_ADD_EVENT_INIT = 'NPVR_ADD_EVENT_INIT';
export const NPVR_ADD_EVENT_SUCCESS = 'NPVR_ADD_EVENT_SUCCESS';
export const NPVR_ADD_EVENT_ERROR = 'NPVR_ADD_EVENT_ERROR';
export const NPVR_ADD_EVENT_CLEAR = 'NPVR_ADD_EVENT_CLEAR';

export const NPVR_ADD_SERIE_INIT = 'NPVR_ADD_SERIE_INIT';
export const NPVR_ADD_SERIE_SUCCESS = 'NPVR_ADD_SERIE_SUCCESS';
export const NPVR_ADD_SERIE_ERROR = 'NPVR_ADD_SERIE_ERROR';
export const NPVR_ADD_SERIE_CLEAR = 'NPVR_ADD_SERIE_CLEAR';

export const NPVR_DELETE_EVENT_INIT = 'NPVR_DELETE_EVENT_INIT';
export const NPVR_DELETE_EVENT_SUCCESS = 'NPVR_DELETE_EVENT_SUCCESS';
export const NPVR_DELETE_EVENT_ERROR = 'NPVR_DELETE_EVENT_ERROR';
export const NPVR_DELETE_EVENT_CLEAR = 'NPVR_DELETE_EVENT_CLEAR';

export const NPVR_DELETE_SERIE_INIT = 'NPVR_DELETE_SERIE_INIT';
export const NPVR_DELETE_SERIE_SUCCESS = 'NPVR_DELETE_SERIE_SUCCESS';
export const NPVR_DELETE_SERIE_ERROR = 'NPVR_DELETE_SERIE_ERROR';
export const NPVR_DELETE_SERIE_CLEAR = 'NPVR_DELETE_SERIE_CLEAR';

export const NPVR_GET_RECORDING_LIST = 'NPVR_GET_RECORDING_LIST';
export const NPVR_GET_RECORDING_LIST_ERROR = ' NPVR_GET_RECORDING_LIST_ERROR';
export const NPVR_GET_RECORDING_LIST_CLEAR = ' NPVR_GET_RECORDING_LIST_CLEAR';
